import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "start",
    background: "#f9f9f9",
    width: "101%",
    border: 0,
    color: "white",
    height: "14%",
    padding: "20px 0",
  },
});
